var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotsee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23332 8.23334C7.98769 8.46221 7.79069 8.73821 7.65405 9.04488C7.51741 9.35154 7.44393 9.68259 7.43801 10.0183C7.43209 10.3539 7.49384 10.6874 7.61957 10.9987C7.74531 11.31 7.93246 11.5927 8.16986 11.8301C8.40725 12.0675 8.69003 12.2547 9.00132 12.3804C9.31262 12.5061 9.64605 12.5679 9.98173 12.562C10.3174 12.5561 10.6484 12.4826 10.9551 12.3459C11.2618 12.2093 11.5378 12.0123 11.7666 11.7667",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94165 4.23332C9.29274 4.18958 9.64618 4.16732 9.99998 4.16666C15.8333 4.16666 18.3333 9.99999 18.3333 9.99999C17.9607 10.7976 17.4935 11.5474 16.9416 12.2333",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50829 5.50833C3.851 6.63718 2.52485 8.18771 1.66663 10C1.66663 10 4.16663 15.8333 9.99996 15.8333C11.5966 15.8376 13.1589 15.3709 14.4916 14.4917",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 1.66666L18.3333 18.3333",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotsee);
export default __webpack_public_path__ + "static/media/notsee.f21a4c3b6d0d8121c7bbc853c38d2ed7.svg";
export { ForwardRef as ReactComponent };